import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCloudSunRain, faWind } from "@fortawesome/free-solid-svg-icons";
import { faLocationDot } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Result } from "antd";
import React, { useMemo } from "react";
import Helper from "../../Helper";
import Weather from "../../Weather";

interface Props {
    textColor?: string;
    weather: any;
    project: any;
}

const CurrentConditions: React.FC<Props> = ({ textColor, weather, project }) => {
    const city = project.city;
    const isMobile = Helper.isMobileDevice();

    const weatherIcon = useMemo(() => {
        return Weather.getWeatherIcon(weather?.current.condition ?? "Unknown");
    }, [weather?.current.condition]);

    return (
        <>
            {weather ? (
                <div className="flex flex-row items-center justify-center h-full w-full">
                    <div className="flex flex-col h-full w-1/2">
                        <div className="flex flex-row h-full justify-center items-center my-2 mx-6 flex-wrap">
                            <FontAwesomeIcon icon={weatherIcon} size={isMobile ? "3x" : "4x"} />
                            <div className="text-5xl mx-4 font-plot-open-sans">
                                {Math.round(weather.current.temperature)}°
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col justify-center h-full text-lg font-plot-open-sans w-1/3">
                        {city && (
                            <div className="flex flex-row items-center text-3xl font-plot-oswald">
                                <FontAwesomeIcon icon={faLocationDot as IconProp} className="mr-2" />
                                {city}
                            </div>
                        )}

                        <div className="font-semibold">{weather.current.condition}</div>
                        <div className="whitespace-nowrap">Feels like {Math.round(weather.current.feels_like)}°</div>

                        <div className="flex flex-row items-center">
                            <FontAwesomeIcon icon={faWind} className="mr-1" />
                            <div className="whitespace-nowrap">
                                {`${weather.current.wind_direction || ""} ${Math.round(weather.current.wind_speed)} MPH`}
                            </div>
                        </div>
                    </div>
                    <img
                        src="/img/png/partner_logos/perry_weather/perry_stacked_color_white_text.svg"
                        alt="Perry Weather Logo"
                        className="h-auto max-h-25"
                    />
                </div>
            ) : (
                <Result
                    className={Helper.classNames("w-full h-full")}
                    icon={<FontAwesomeIcon icon={faCloudSunRain} size="3x" />}
                    title={<div className={textColor}>Weather currently unavailable</div>}
                />
            )}
        </>
    );
};

export default CurrentConditions;
